import { isGrantReviewPortal } from "@/environment";
export default {
  to: "/dashboard/upgrade-list",
  order: 2,
  icon: "mdi-upload-outline",
  title: "Upgrade Applications",
  disabled: JSON.parse(isGrantReviewPortal) ? true : false,
  sublinks: [
    {
      to: `/dashboard/upgrade/list`,
      order: 1,
      title: "My Upgrades",
      disabled: false,
      icon: "mdi-format-list-numbered",
    },
    {
      to: `/dashboard/upgrade/prb`,
      order: 1,
      title: "PRB List",
      disabled: false,
      icon: "mdi-format-list-checks",
    },
    {
      to: `/dashboard/upgrade/prb-interview`,
      order: 1,
      title: "Interview Stage",
      disabled: false,
      icon: "mdi-table-chair",
    },
    {
      to: `/dashboard/upgrade/reports`,
      order: 2,
      title: "Reports",
      disabled: false,
      icon: "mdi-file-chart",
    },
  ],
};
